exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.required-field > label[data-v-a571a8cc]::after  {\n    content: '*';\n    color: red;\n    margin-left: 0.25rem;\n}\n.form-control-feedback[data-v-a571a8cc] {\n    font-weight: 100;\n    color: red;\n    position: initial;\n    text-align: left;\n    height: auto;\n    width: auto;\n}\n.gradientbt[data-v-a571a8cc]{\n    background: #0F6940;\n    color: white\n}\n.box-header[data-v-a571a8cc]{\n    background: #0F6940;\n    color: white\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-a571a8cc","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/trip/UpdateDestination.vue
// module id = 224
// module chunks = 0